import { gql } from '@apollo/client';

export type List = {
  id: string;
  name: string;
};

export const fetchListsQuery = gql`
  query getLists(
    $filterInfo: ListFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
    $ids: [Long!]
  ) {
    lists(
      filterInfo: $filterInfo
      pagination: $pagination
      sort: $sort
      search: $search
      ids: $ids
    ) {
      results {
        id
        name
      }
    }
  }
`;

export const parseListsResponse = (resp: unknown): List[] | undefined =>
  (resp as any)?.lists?.results;

export const fetchListQuery = gql`
  query getList($id: Long!) {
    list(id: $id) {
      name
      id
    }
  }
`;

export const parseListResponse = (resp: unknown): List | undefined => (resp as any)?.list;
